import { Language } from '../GUI/Language';

import { BalanceManagerSetup } from './BalanceManager'
import { GameState } from './GameState'
import { Authenticated, betTableEntry, PlayerInfo, PlayboardMode, HistorySnapshot } from './Links/IMAXA/IMAXAProtocol'
import { Stake, BetTypeInfo, BetFieldInfo } from './BetStake'
import { RouletteConfig, RouletteHistorySnapshot, videoSource } from "BaseRoulette/Sources/Logic/Links/IMAXA/IMAXAProtocol";
import { VIDEO_TYPE } from './Logic';
import { convertHistoryToRouletteHistory } from '@core/Utils/HelperFunction';

export class GameSetup {
	DoubleZero: boolean = false;

	BETS_TABLE_MAX_X = 26
	BETS_TABLE_MAX_Y = 11

	HOST = {
		host: '4knh.com',
		port: 7997
	}

	USER = {
		Name: 'neki',
		Nickname: 'neki2',
		Session: 'nekiSession',
		UID: '1234',
		Demo: false,
		LogoutSupported: true,
		PayoutEnabled: true,
		ShowUsername: true
	}

	Currency: string

	MaxBet:number = 0;

	BetTypes: BetTypeInfo[]
	BetFields: BetFieldInfo[][]
	BetPresets: any

	Stakes: Stake[]
	SelectedStake: number
	StakeChangeAllowed: boolean;

	Recovery: RouletteHistorySnapshot = null;
	GameHistory: Array<RouletteHistorySnapshot> = new Array<RouletteHistorySnapshot>();
	MaxHistorySize: number = 200;

	InitialGameState: GameState;

	BalanceManagerSetup: BalanceManagerSetup = {
		jurisdiction: 'default',
		denomination: 0.1,
		initialCredit: []
	}

	AuthenticationRequired = false

	videoPlayerSettings: {
		type: VIDEO_TYPE,
		sources: Array<videoSource>
	}

	CurrencyValue = 1;

	PlayerList: PlayerInfo[];

	DefaultAudio = "";

	Domain = ''

	ProviderType = 1;

	Jackpot = {
		type: null,
		currency: null,
		levels: null
	}

	Spectator: boolean
	PilotSeat: boolean //Allows YServer to remote control the game
	Locale = 'en_us'

	startVoteEnabled: boolean = false;

	playboardMode: PlayboardMode = PlayboardMode.NORMAL;
}

export function generateSetupFromInit(i: Authenticated): GameSetup {
	let setup: GameSetup = new GameSetup();
	let gameConfig: RouletteConfig = i.game as RouletteConfig;

	if (i.host.type == 3) // 3 = VirtualRoulette
		setup.DoubleZero = gameConfig.config.doubleZero;
	else
		setup.DoubleZero = i.host.info.doubleZero;

	setup.BetTypes = [];
	gameConfig.config.betTypes.forEach((infoObj: any) => {
		setup.BetTypes.push(new BetTypeInfo(infoObj));
	});

	if (gameConfig.config.playboardMode)
		setup.playboardMode = gameConfig.config.playboardMode;

	setup.BetFields = [];
	gameConfig.config.betTable.forEach((col: betTableEntry[]) => {
		let column = new Array<BetFieldInfo>();
		col.forEach((field: betTableEntry) => {
			column.push(new BetFieldInfo(field))
		});
		setup.BetFields.push(column);
	});

	setup.BetPresets = gameConfig.config.betPresets;

	setup.startVoteEnabled = i.host.info.startVoteEnabled;

	setup.Stakes = [];
	gameConfig.config.stakes.forEach((stakeObj: any) => {
		setup.Stakes.push(new Stake(stakeObj));
	});

	setup.SelectedStake = gameConfig.config.selectedStake;
	setup.StakeChangeAllowed = i.host.info.stakeChangeAllowed;

	setup.MaxBet = gameConfig.maxBet;

	// Balance manager setup, TODO: jurisdiction and denomination from config!?
	setup.BalanceManagerSetup.jurisdiction = '';
	setup.BalanceManagerSetup.denomination = i.denomination;
	setup.Currency = i.currency
	setup.BalanceManagerSetup.initialCredit = i.balance;

	if (i.currency) {
		Language.currency = i.currency;
		Language.UpdateInternationalNumberFormat();
	}

	// initial game state stuff:
	setup.InitialGameState = new GameState();
	setup.InitialGameState.ID = gameConfig.state.ID;
	setup.InitialGameState.phase = gameConfig.state.phase;
	setup.InitialGameState.phaseSubID = gameConfig.state.phaseSubID;

	setup.InitialGameState.timeLeft = gameConfig.state.timeLeft;
	setup.InitialGameState.totalTime = gameConfig.state.totalTime;

	setup.InitialGameState.winNumber = gameConfig.state.winNumber;
	setup.InitialGameState.Balance = i.balance;

	if (gameConfig.jackpot) {
		setup.Jackpot.type = gameConfig.jackpot.type;
		setup.Jackpot.currency = gameConfig.jackpot.currency;
		if (!setup.Jackpot.currency || setup.Jackpot.currency == "undefined") {
			setup.Jackpot.currency = "";
		}
		setup.Jackpot.levels = gameConfig.jackpot.levels;
		setup.InitialGameState.jackpot = {};
		if (gameConfig.state.jackpot)
			setup.InitialGameState.jackpot.state = gameConfig.state.jackpot;
	}

	setup.InitialGameState.DoubleZero = setup.DoubleZero;

	if (gameConfig.historyNumbers[0]!= null && !(gameConfig.historyNumbers[0].constructor === Array)) {
		let history: Array<number[]> = new Array<number[]>();
		for (let i: number = 0; i < gameConfig.historyNumbers.length; i++) {
			history[i] = [0, gameConfig.historyNumbers[i]];
		}
		gameConfig.historyNumbers = history;
	}

	setup.InitialGameState.SetHistoryNumbers(gameConfig.historyNumbers);

	// recovery Historic state
	if (gameConfig.unfinished) {
		setup.Recovery = convertHistoryToRouletteHistory(gameConfig.unfinished, gameConfig.config.betPresets);
	}

	i.history.forEach(element => {
		if (element.data)//if data is null, it is an invalid snapshot
			setup.GameHistory.push(convertHistoryToRouletteHistory(element, gameConfig.config.betPresets));
	});

	setup.MaxHistorySize = gameConfig["max-history-size"];

	setup.USER.Name = i.account.name;
	setup.USER.Nickname = i.account.nickname;
	setup.USER.Session = i.account.session;
	setup.USER.UID = i.account.UID;
	setup.USER.Demo = i.account.demo;
	setup.USER.LogoutSupported = i.account.logoutSupported;
	setup.USER.PayoutEnabled = i.account.payoutEnabled;
	setup.USER.ShowUsername = i.account.showUsername;

	setup.videoPlayerSettings = gameConfig.stream;

	setup.CurrencyValue = i.currencyValue

	let gamePlayersArray = []
	if (gameConfig.players) {
		for (let n = 0; n < Object.keys(gameConfig.players).length; n++) {
			let player = gameConfig.players[Object.keys(gameConfig.players)[n]]
			gamePlayersArray.push({ id: Object.keys(gameConfig.players)[n], nickname: player.nickname, chat: player.chat, number: player.number })
		}
	}
	setup.PlayerList = gamePlayersArray

	if (!setup.USER.Nickname || setup.USER.Nickname.length === 0) {
		gamePlayersArray.forEach(element => {
			if (element.id == setup.USER.UID) {
				setup.USER.Nickname = "Anonymous" + (element.number + 1);
			}
		});
	}

	gamePlayersArray.forEach(element => {
		if (element.nickname == '') {
			element.nickname = "Anonymous" + (element.number + 1);
		}
	});

	if (i.provider) {
		setup.AuthenticationRequired = i.provider.authenticationRequired;

		if (i.provider.domain)
			setup.Domain = i.provider.domain;
		if (i.provider.type)
			setup.ProviderType = i.provider.type;
	}

	setup.DefaultAudio = gameConfig.config['default-audio'];

	setup.Spectator = i.spectator

	setup.PilotSeat = i.pilotSeat

	if (i.locale) setup.Locale = i.locale

	return setup;
}